module.exports = __webpack_public_path__ + "img/lumberjack.hatchet.8ef78702.png";